import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import { businessQuery, siteMutation, themeMutation } from '@queries';
import { ChevronRightIcon } from '@svgs';

import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';

import { TemplateForm } from './TemplateForm/TemplateForm.jsx';

export const AddTemplate = () => {
  const { t, i18n } = useTranslation();
  const { businessID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // mutations for creating the theme, site and then updating the theme
  const createSite = useMutation(siteMutation(null));
  const createTheme = useMutation(themeMutation(null));
  const updateTheme = useMutation(
    themeMutation(null, {
      onSuccess: (data) => {
        // invalidate list views so they are re-fetched
        queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/projects/${businessID}/templates`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <Link to={`/dashboard/projects/${businessID}/templates`}>
                Templates
              </Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">Add</li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            <h1>Add</h1>
            {businessIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {businessData && (
              <TemplateForm
                businessData={businessData}
                createSite={createSite}
                createTheme={createTheme}
                updateTheme={updateTheme}
                onCancel={() => {
                  navigate(`/dashboard/projects/${businessID}/templates`);
                }}
              />
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
